import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpointsColors } from "../api/endpoints"
import { colorsTypes } from "../constantes/actionTypes"

export const colorsActions = {
    getColors: () => (
        createMiddlewareAction({
            successType: colorsTypes.GET_ALL_COLORS_SUCCESS,
            failureType: colorsTypes.GET_ALL_COLORS_FAILURE,
            method: "GET",
            endpoint: endpointsColors.GET_ALL_COLORS
        })
    ),
}